<template>
  <div class="memory-bank">
    <div class="header">
      <button class="create primary"
              @click="handleUpload">{{$t('newProjectV2.uploadMemory')}}</button>
      <div class="header-right">
        {{$t('newProjectV2.mounted')}}<span class="num">{{mountNum}}</span>
        <button @click="handleMount" class="mount primary">{{$t('newProjectV2.mount')}}</button>
        <button @click="handleCancelAll" class="create">{{$t('newProjectV2.cancelAll')}}</button>
      </div>
    </div>
    <div class="memory-content">
      <el-table border height="100%" ref="multipleTable" :data="memoryList" tooltip-effect="dark"
                @selection-change="handleSelectionChange" header-row-class-name="customHeader">
        <el-table-column align="center" type="selection" width="55">
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.serialNumber')" align="center" width="55">
          <template slot-scope="{ $index }">
            {{$index + 1}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.memoryBankName')" align="center" prop="name"
                         :show-overflow-tooltip='true'></el-table-column>
        <el-table-column :label="$t('newProjectV2.domain')" align="center">
          <template slot-scope="{ row }">
            {{ $i18n.locale === 'zh' ? row.domainName : $domainCase[row.domainCode] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.sentNum')" align="center" prop="sentCount"
                         :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column :label="$t('newProjectV2.mount')" align="center" prop="isEnable">
          <template slot-scope="{ row }">
            <el-switch v-model="row.isEnable" active-color="#0078FC" inactive-color="#DCDCDC">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="memory-bottom">
      {{$t('newProjectV2.matchRate')}}<el-select size="small" @change="matchRateChange"
                 v-model="matchingRate" placeholder="请选择">
        <el-option label="70" :value="70"></el-option>
        <el-option label="80" :value="80"></el-option>
        <el-option label="90" :value="90"></el-option>
      </el-select>%
    </div>

    <!-- <UploadMemoryBank
      type="create"
      :visible="uploadVisible"
      @handleCancel="handleUploadCancel"
      @updateMemoryBank="updateMemoryBank"
    ></UploadMemoryBank> -->
    <!-- 新版上传弹窗 -->
    <UploadCorpus bankType="memory" title="upload" uploadType="project"
                  :dialogVisible="uploadVisible" :corpusDetailInfo="queryInfo"
                  @handleClose="handleUploadCancel" @handleConfirm="updateMemoryBank"
                  :accept="accept" />
  </div>
</template>

<script>
import UploadCorpus from '@/views/corpus/components/corpusDetailUploadDialog';

export default {
  name: 'MemoryBank',
  props: {
    memoryList: {
      type: Array,
      default() {
        return [];
      }
    },
    matchRate: {
      type: Number,
      default() {
        return 0;
      }
    },
  },
  components: {
    UploadCorpus
  },
  data() {
    return {
      memorySelection: [],
      matchingRate: this.matchRate,
      uploadVisible: false,
      accept: '.xlsx, .txt, .tmx, .zip',
      queryInfo: JSON.parse(this.$Base64.decode(this.$route.query.key))
    }
  },
  methods: {
    // checkbox的change事件
    handleSelectionChange(selection) {
      this.memorySelection = selection;
    },
    handleCancelAll() {
      this.memoryList.forEach(item => {
        item.isEnable = false;
      });
      this.$refs.multipleTable.clearSelection();
    },
    handleMount() {
      if (this.memorySelection.length === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.selMemoryBankTip'));
      }
      this.memorySelection.forEach(item => {
        this.memoryList.forEach(i => {
          if (i.id === item.id) {
            i.isEnable = true;
          }
        });
      });
      // 取消选中
      this.$refs.multipleTable.clearSelection();
    },
    matchRateChange(newVal) {
      this.$emit('matchRateChange', newVal)
    },
    handleUpload() {
      this.uploadVisible = true;
    },
    handleUploadCancel() {
      this.uploadVisible = false;
    },
    updateMemoryBank() {
      this.uploadVisible = false;
      this.$message.success(this.$t('newProjectV2.uploadSuccess'));
      this.$emit('updateMemoryBank', 'memory');
    },
  },
  computed: {
    mountNum() {
      return this.memoryList.filter(item => item.isEnable === true).length;
    }
  }
}
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>